// src/utils/preloadRoutes.js
import machineService from '../services/admin/machineService';
import correctionTypeService from '../services/admin/correctionTypeService';
import downtimeService from '../services/admin/downtimeService';
import departmentService from '../services/departmentService';
import defectTypeService from '../services/admin/defectTypeService';
import productionService from '../services/productionService';

export function preloadOperatorRoutes() {
    if (!navigator.onLine) return;

    // producción (CRÍTICAS)
    import('views/pages/operator/production/PieceRecordForm');
    import('views/pages/operator/production/PieceRecordFunctionalForm');
    import('views/pages/operator/production/PieceRecordNonFunctionalForm');
    import('views/pages/operator/production/PieceDefectTypesForm');
    import('views/pages/operator/production/DefectDistributionForm');

    import('views/pages/operator/EditReportRequestsPage');
    import('views/pages/operator/EditDistributionList');
    import('views/pages/operator/EditDistributionForm');

    import('views/pages/operator/TechnicSupportsPage');
    import('views/pages/authentication/authentication3/Login3');
    import('views/pages/panel/Panel');
    import('views/pages/operator/ProductionStatsPage');
}

// utils/preloadCatalogs.js

export async function preloadCatalogs(id) {
    try {
        await Promise.all([
            machineService.getMyAssignedMachine(id),
            correctionTypeService.listEnabled(),
            downtimeService.listEnabledDownTimeTypes(),
            departmentService.listEnabledDeparments(),
            defectTypeService.listEnabledDefectTypes(),
            productionService.listMyRecords()
        ]);

        console.log('📦 Catálogos precargados');
    } catch (error) {
        console.warn('⚠️ Error precargando catálogos', error);
    }
}
